module.exports = __webpack_public_path__ + "img/DE00357.9749d882.png";